// Vendors
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './hover-select-option.scss';

type Props = {
  label: string,
  description?: string,
  onClick: Function,
};

const HoverSelectOption = ({ label, description, onClick }: Props) => (
  <button
    type="button"
    className="hover-select-option"
    onClick={onClick}
  >
    <span className="hover-select-option__content">
      <span className="hover-select-option__label">{label}</span>
      {description && (
        <span className="hover-select-option__description">{description}</span>
      )}
    </span>
  </button>
);

HoverSelectOption.propTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

HoverSelectOption.defaultProps = {
  description: null,
};

export default HoverSelectOption;